import axios from 'axios'
import qs from 'qs'

import { normalizeError } from './utils'

const seleneReindexService = () => {
  const fetchVerticals = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/selene/verticals', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchVersions = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/selene/versions', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchTemplateTypes = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/selene/templatetypes', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchVerticalStatus = async (accessToken, verticalName, indexName, templateTypes) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/selene/status/${verticalName}/${indexName}?${qs.stringify({ templateTypes })}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchVerticalProgress = async (accessToken, verticalName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/selene/progress/${verticalName}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const startReindex = async (accessToken, verticalName, templateTypes) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.put(`/api/selene/reindex/${verticalName}?${qs.stringify({ templateTypes })}`, null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const stopReindex = async (accessToken, verticalName) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.delete(`/api/selene/reindex/${verticalName}`, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const setVersions = async (accessToken, versions) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/selene/versions`, versions, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const reindexById = async (accessToken, documentIds) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/selene/reindex`, documentIds, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return {
    fetchVerticals,
    fetchVersions,
    fetchTemplateTypes,
    fetchVerticalStatus,
    fetchVerticalProgress,
    startReindex,
    stopReindex,
    setVersions,
    reindexById,
  }
}

export default seleneReindexService()
